var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7823 10.1541C12.492 10.4444 12.0213 10.4444 11.7309 10.1541L6.9999 5.42327L2.26906 10.1541C1.97874 10.4444 1.50805 10.4444 1.21774 10.1541C0.927422 9.86376 0.927422 9.39307 1.21774 9.10276L6.47434 3.84615C6.76465 3.55584 7.23535 3.55584 7.52566 3.84615L12.7823 9.10276C13.0726 9.39307 13.0726 9.86376 12.7823 10.1541Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowUp);
export default __webpack_public_path__ + "static/media/icn_arrow_up.5fc34735d184f7605f13c90a565ea175.svg";
export { ForwardRef as ReactComponent };